import { NEW_PHOTO_BOOK_SEGMENT, PHOTO_BOOK_URL } from 'config/config'
import { PHOTO_BOOK_ID_LENGTH } from 'services/PhotoBook/photoBookId'

// Book ids are fixed-length base62, so the editor's paths can be described
// exactly — the marketing pages under /photo-books miss the id window by
// length and need no naming here.
const PHOTO_BOOK_EDITOR_PATH_REGEX = new RegExp(
  `^${PHOTO_BOOK_URL}(/(${NEW_PHOTO_BOOK_SEGMENT}|[0-9A-Za-z]{${PHOTO_BOOK_ID_LENGTH}}))?$`
)

// Bare /photo-books is the editor too — it resolves an id and redirects — so a
// notice there still waits for a book to paint.
export function isPhotoBookEditorPath(pathname: string): boolean {
  return PHOTO_BOOK_EDITOR_PATH_REGEX.test(pathname)
}
